module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-10.def7e1bf.svg";